import { useEffect, useState } from 'react';
import {
  Layout,
  TextContainer,
  TextStyle,
  Heading,
  Icon,
  Link,
} from '@shopify/polaris';
import { SettingsMinor } from '@shopify/polaris-icons';
import Switch from 'react-switch';
import {
  CRM_TEMPLATE_DICT,
  TEMPLATE_LANGUAGE_ARAB,
  TEMPLATE_LANGUAGE_DUTCH,
  TEMPLATE_LANGUAGE_ENG,
  TEMPLATE_LANGUAGE_FREN,
  TEMPLATE_LANGUAGE_GERM,
  TEMPLATE_LANGUAGE_HEBR,
  TEMPLATE_LANGUAGE_INDO,
  TEMPLATE_LANGUAGE_ITAL,
  TEMPLATE_LANGUAGE_PORT,
  TEMPLATE_LANGUAGE_SPAN,
  TEMPLATE_LANGUAGE_TURK,
  TEMPLATE_LANGUAGE_RUSSIAN,
  OPTIN_ENTERPRISE_TEMPLATES,
} from '../../../../constants/constants';
import OrderShipmentModal from './OrderShipmentModal';
import { updateOrderSettings } from '../../../../redux/actions/crmOrders';
import {
  clevertapEventPush,
  CT_EVENT_IDS,
} from '../../../../utils/clevertapUtils';

function OrderShipment({
  shopId,
  showToast,
  showErrorToast,
  phoneData,
  orderConfirmationLanguage,
  orderShipmentData,
  isOrderShipmentEnabled,
  setIsOrderShipmentEnabled,
  checkForApproval,
  privateWabaDetails,
  optinEnterpriseTemplates,
}: any) {
  var TEMPLATE_DICT: any = CRM_TEMPLATE_DICT;
  const [
    openOrderConfirmationSettingsModal,
    setOpenOrderConfirmationSettingsModal,
  ] = useState(false);

  const getOrderTrackingPreview = () => {
    switch (orderConfirmationLanguage) {
      case TEMPLATE_LANGUAGE_ENG:
        return 'https://cdn.shopify.com/s/files/1/0070/3666/5911/files/eng-order_shipment_perview.png?v=1587749557';
      case TEMPLATE_LANGUAGE_PORT:
        return 'https://cdn.shopify.com/s/files/1/0070/3666/5911/files/por-order_shipment_perview.png?v=1587749558';
      case TEMPLATE_LANGUAGE_SPAN:
        return 'https://cdn.shopify.com/s/files/1/0070/3666/5911/files/spa-order_shipment_perview.png?v=1587749557';
      case TEMPLATE_LANGUAGE_ITAL:
        return 'https://cdn.shopify.com/s/files/1/0070/3666/5911/files/ita-order_shipment_perview.png?v=1587749557';
      case TEMPLATE_LANGUAGE_FREN:
        return 'https://cdn.shopify.com/s/files/1/0070/3666/5911/files/fr-order_shipment_perview.png?v=1587749558';
      case TEMPLATE_LANGUAGE_INDO:
        return 'https://cdn.shopify.com/s/files/1/0070/3666/5911/files/indo-order_shipment_perview.png?v=1587749557';
      case TEMPLATE_LANGUAGE_GERM:
        return 'https://cdn.shopify.com/s/files/1/0070/3666/5911/files/ger-order_shipment_perview.png?v=1587749558';
      case TEMPLATE_LANGUAGE_ARAB:
        return 'https://cdn.shopify.com/s/files/1/0070/3666/5911/files/arabic-order_shipment_perview.png?v=1587749557';
      case TEMPLATE_LANGUAGE_TURK:
        return 'https://cdn.shopify.com/s/files/1/0070/3666/5911/files/turkish-order_shipment_perview.png?v=1587819647';
      case TEMPLATE_LANGUAGE_HEBR:
        return 'https://cdn.shopify.com/s/files/1/0070/3666/5911/files/hebrew-order_shipment_perview.png?v=1591679011';
      case TEMPLATE_LANGUAGE_DUTCH:
        return 'https://cdn.shopify.com/s/files/1/0070/3666/5911/files/dutch-order_shipment_perview.png?v=1591677401';
      case TEMPLATE_LANGUAGE_RUSSIAN:
        return 'https://cdn.shopify.com/s/files/1/0449/7794/6790/files/russian_order_shipment.png?v=1654750457';
    }
  };

  const enableOrderConfirmation = (enabled: boolean) => {
    if (!checkForApproval()) return;
    if (
      !phoneData.phone ||
      !phoneData.countryCode ||
      phoneData.phone.length === 0 ||
      phoneData.countryCode.length === 0
    ) {
      showErrorToast(
        'Please add a Whatsapp Support number by going to Admin Configuration'
      );
      return;
    }
    var params: any = new URLSearchParams();
    params.append('shipmentEnabled', enabled);
    updateOrderSettings(shopId, params).then(
      (response: any) => {
        if (response.status === 'success') {
          setIsOrderShipmentEnabled(response.settings.shipmentEnabled);
          showToast(
            'Order Shipment message template has been ' +
              (enabled ? 'ENABLED' : 'DISABLED')
          );
          if (enabled) {
            clevertapEventPush({
              eventId: CT_EVENT_IDS.AUTOMATED_TEMPLATE_MESSAGE_ENABLED,
              eventData: {
                template_name: 'Order Shipment',
                template_language: orderShipmentData.language,
                'Private waba':
                  localStorage.getItem('private_waba') === 'true'
                    ? true
                    : false,
              },
            });
          } else {
            clevertapEventPush({
              eventId: CT_EVENT_IDS.AUTOMATED_TEMPLATE_MESSAGE_DISABLED,
              eventData: {
                template_name: 'Order Shipment',
                template_language: orderShipmentData.language,
                'Private waba':
                  localStorage.getItem('private_waba') === 'true'
                    ? true
                    : false,
              },
            });
          }
        } else {
          showErrorToast(response);
        }
      },
      (err: any) => {
        showErrorToast('Something went wrong');
      }
    );
  };

  const orderConfirmationMarkup = () => {
    return (
      <>
        <Layout.Section>
          <div className='template-info-container'>
            <div className='Polaris-TextContainer Polaris-TextContainer--spacingTight template-info'>
              <div className='templateSwitchMobCss'>
                <Heading>Order Shipment</Heading>
                <Switch
                  onChange={() =>
                    enableOrderConfirmation(!isOrderShipmentEnabled)
                  }
                  checked={isOrderShipmentEnabled}
                  onColor='#5DC001'
                  onHandleColor='#fff'
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow='0px 1px 5px rgba(0, 0, 0, 0.6)'
                  activeBoxShadow='0px 0px 1px 6px rgba(0, 0, 0, 0.2)'
                  height={20}
                  width={48}
                  handleDiameter={30}
                />
              </div>
              <span>
                {isOrderShipmentEnabled ? (
                  <p>
                    Order shipment message is sent when you fulfill an order in
                    the Shopify admin.
                  </p>
                ) : (
                  <p>
                    Order shipment messages get customers excited about their
                    purchases and boosts customer gratification.
                  </p>
                )}
                <br />
              </span>
            </div>
            <div className='Polaris-Card w-100'>
              <div className='Polaris-Card__Section break-word'>
                <TextContainer>
                  <TextStyle>
                    <span
                      dangerouslySetInnerHTML={{
                        __html:
                          optinEnterpriseTemplates &&
                          orderConfirmationLanguage === 'ENGLISH'
                            ? OPTIN_ENTERPRISE_TEMPLATES.order_tracking_template
                            : TEMPLATE_DICT[orderConfirmationLanguage][
                                'order_tracking_template'
                              ],
                      }}
                    ></span>

                    <br />
                    <br />
                    <Link
                      external={true}
                      url={getOrderTrackingPreview()}
                      onClick={() => {
                        clevertapEventPush({
                          eventId:
                            CT_EVENT_IDS.AUTOMATED_TEMPLATE_MESSAGE_PREVIEWED,
                          eventData: {
                            template_name: 'Order Shipment',
                            template_language: orderShipmentData.language,
                            'Private waba':
                              localStorage.getItem('private_waba') === 'true'
                                ? true
                                : false,
                          },
                        });
                      }}
                    >
                      Preview
                    </Link>
                  </TextStyle>
                </TextContainer>
              </div>
              {isOrderShipmentEnabled ? (
                <div className='w-100'>
                  <div className='Polaris-Page--divider'></div>
                  <div className='Polaris-Card__Section break-word pt-0'>
                    <TextContainer>
                      <TextStyle variation='subdued'>
                        <span className='Polaris-TextStyle--variationSubdued'>
                          <b>Note</b>: Order Shipment template language is based
                          on language set in Order Confirmation.
                        </span>
                      </TextStyle>
                    </TextContainer>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </Layout.Section>
        <div className='template Polaris-Layout__Section Polaris-Layout__Section--secondary m-auto text-center'>
          <div className='flex-col w-100'>
            <div>
              <button
                className={
                  isOrderShipmentEnabled
                    ? 'Polaris-Button Polaris-Button--primary Polaris-Button--outline w-50'
                    : 'Polaris-Button Polaris-Button--outline Polaris-Button--disabled w-50'
                }
                type='button'
                disabled={!isOrderShipmentEnabled}
                onClick={() => setOpenOrderConfirmationSettingsModal(true)}
              >
                <span className='Polaris-Button__Content'>
                  <span className='Polaris-Button__Text'>
                    <div className='d-flex-center'>
                      <div>
                        <Icon source={SettingsMinor} />
                      </div>
                      <div>&nbsp;Settings</div>
                    </div>
                  </span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </>
    );
  };
  return (
    <>
      {shopId ? (
        <>
          {orderConfirmationMarkup()}
          <OrderShipmentModal
            open={openOrderConfirmationSettingsModal}
            closeModal={() => setOpenOrderConfirmationSettingsModal(false)}
            showToast={showToast}
            showErrorToast={showErrorToast}
            orderShipmentData={orderShipmentData}
          />
        </>
      ) : null}
    </>
  );
}

export default OrderShipment;
